import * as React from 'react';

import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './bv-container-loader.scss';

interface IBVContainerLoader {
    loading?: boolean
}

const BVContainerLoader: React.FunctionComponent<IBVContainerLoader> = ({ loading }) => (
    <React.Fragment>
        {loading &&
            <div className="bv-container-loader">
                <Spin
                    className="bv-spinner-indicator"
                    indicator={<LoadingOutlined style={{ fontSize: '3rem' }} />}
                />
            </div>
        }
    </React.Fragment>
);

export default BVContainerLoader;